"use client";

import { Truck, DollarSign, Package } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyChooseSmartBuyAppliances() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const benefits = [{
    icon: DollarSign,
    title: "Unbeatable Prices",
    description: "Steep discounts on top-quality appliances for Raleigh-Durham area residents"
  }, {
    icon: Truck,
    title: "Fast Local Delivery",
    description: "Efficient delivery and installation service throughout Raleigh, Durham, and surrounding NC areas"
  }, {
    icon: Package,
    title: "Large Inventory in Raleigh",
    description: "Wide selection of appliances in stock at our 4100 Atlantic Ave location"
  }];
  return <section ref={containerRef} className="relative overflow-hidden bg-dark-background py-20 transition-all duration-[var(--duration-slow)]" style={{
    background: isVisible ? "linear-gradient(135deg, hsl(210, 9%, 18%) 0%, hsl(210, 12%, 22%) 100%)" : "hsl(210, 9%, 18%)"
  }}>
      <div className="container mx-auto px-6">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground-dark text-center mb-4">
          Why Choose Smart Buy Appliances
        </h2>
        <p className="text-center text-foreground-dark/70 text-lg mb-12 max-w-2xl mx-auto">
          Your trusted appliance store in Raleigh, NC - serving the Triangle area since day one
        </p>
        
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <div key={i} data-index={i} className="flex flex-col items-center text-center" style={{
            animation: isVisible ? `bounce-in var(--duration-slow) var(--ease-spring) both ${i * 150}ms` : "none"
          }}>
                <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-primary/20 text-primary transition-all duration-[var(--duration-medium)] hover:bg-primary/30 hover:shadow-[0_0_20px_rgba(78,138,217,0.4)]" style={{
              animation: isVisible ? `glow-pulse 2s ease-in-out infinite ${i * 300}ms` : "none"
            }}>
                  <Icon className="h-10 w-10" strokeWidth={2} />
                </div>
                <h3 className="mb-3 font-display text-xl font-semibold text-foreground-dark">
                  {benefit.title}
                </h3>
                <p className="text-foreground-dark/80">{benefit.description}</p>
              </div>;
        })}
        </div>
      </div>

      <style jsx>{`
        @keyframes bounce-in {
          0% {
            opacity: 0;
            transform: translateY(-40px) scale(0.8);
          }
          50% {
            transform: translateY(10px) scale(1.05);
          }
          100% {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        @keyframes glow-pulse {
          0%,
          100% {
            box-shadow: 0 0 15px rgba(78, 138, 217, 0.3);
          }
          50% {
            box-shadow: 0 0 25px rgba(78, 138, 217, 0.5);
          }
        }

        @media (prefers-reduced-motion: reduce) {
          * {
            animation: none !important;
            transition: none !important;
          }
        }
      `}</style>
    </section>;
}